import * as React from 'react';

export const ptFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_351)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#EE151F'
            />
            <mask
                id='mask0_1_351'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_351)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H9.33333V20H0V0Z'
                    fill='#006032'
                />
                <path
                    d='M9.33334 13.3333C11.5425 13.3333 13.3333 11.5425 13.3333 9.33333C13.3333 7.12419 11.5425 5.33333 9.33334 5.33333C7.1242 5.33333 5.33334 7.12419 5.33334 9.33333C5.33334 11.5425 7.1242 13.3333 9.33334 13.3333Z'
                    fill='#FFDA2C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 10.6667V6.66667H6.66666V10.6667C6.66666 11.4027 7.85999 12 9.33332 12C10.8067 12 12 11.4027 12 10.6667Z'
                    fill='#EE151F'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 8H10.6667V10.6667H8V8Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 8H9.33333V9.33333H8V8ZM9.33333 9.33333H10.6667V10.6667H9.33333V9.33333Z'
                    fill='#1A47B8'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_351'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
